//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/** Represents the NCOA type. */
export const NcoaType = {
    /** None */
    None: 0,

    /** No Move */
    NoMove: 1,

    /** 48 Month Move */
    Month48Move: 2,

    /** Move */
    Move: 3
} as const;

/** Represents the NCOA type. */
export const NcoaTypeDescription: Record<number, string> = {
    0: "None",

    1: "No Move",

    2: "Month 48 Move",

    3: "Move"
};

/** Represents the NCOA type. */
export type NcoaType = typeof NcoaType[keyof typeof NcoaType];
